import api from '../axios';

export const get_renovation_month = async () => {
  try {
    const response = await api.get('/customers/renovations/month');
    return response.data;
  } catch (error) {
    console.error('Error fetching month renovations:', error);
    return null;
  }
};

export const get_renovation_nexttendays = async () => {
  try {
    const response = await api.get('/customers/renovations/nexttendays');
    return response.data;
  } catch (error) {
    console.error('Error fetching 10-day renovations:', error);
    return null;
  }
};

export const send_email_report = async () => {
  try {
    const response = await api.get('/monitor/send_email_report');
    return response.data;
  } catch (error) {
    console.error('Error sending email report:', error);
    return null;
  }
};

export const renovation_customer = async (data) => {
  try {
    const response = await api.post('/customers/renovation', data);
    return response.data;
  } catch (error) {
    console.error('Error renovating customer:', error);
    return null;
  }
};
